/**
 * Extract the `:sessionId` segment from a `/sessions/<id>/...` pathname.
 *
 * Runs and calibrations can be viewed either standalone (`/runs/:runId`) or in a
 * session context (`/sessions/:sessionId/runs/:runId`). When the id isn't in the
 * route params it has to be recovered from the URL — this centralises the
 * split-and-find-`sessions` logic that was previously copy-pasted across
 * RunView and CalibrationView.
 *
 * @returns the session id, or undefined if the pathname has no `/sessions/<id>` segment.
 */
export function sessionIdFromPath(pathname: string): string | undefined {
  const parts = pathname.split('/');
  const i = parts.findIndex((part) => part === 'sessions');
  return i !== -1 && parts[i + 1] ? parts[i + 1] : undefined;
}
